<ng-container *abcLet="res$ | async as res">
  <div class="containerMileage resource_event_border">
    <div class="detailContainerMileage">
      <div fxLayout="row" class="icon-container">
        <mat-icon
          class="iconHeaderMileage"
          [svgIcon]="res.svgName(this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.iconName)"
        ></mat-icon>
        <span class="resource_event_boldLabel">{{
          this.resourcesNavigationContext.resourceEventGroup.resource.name
        }}</span>
      </div>
      <resource-navigation></resource-navigation>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" class="startContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'date')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.date"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'time')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.time"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="kilometerHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'value')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleMileage-KmStart')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.value"
            [ngStyle]="{ width: '180px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" class="endContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endDate')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="'true'"
            [value]="this.resourceEvent?.endDate"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endTime')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="'true'"
            [value]="this.resourceEvent?.endTime"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="kilometerHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'endValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleMileage-KmEnd')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.endValue"
            [ngStyle]="{ width: '180px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end none" style="margin-bottom: 20px">
        <div>
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'resultValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleMileage-UsedKm')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.resultValue"
            [ngStyle]="{ width: '180px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <abc-text-area
          (onValueChanged)="safeSetValue($event, 'comment')"
          [disabled]="this.isDisabled"
          [height]="'90px'"
          [labelMode]="'floating'"
          [label]="res.get('Resources-ResourceEventVehicleMileage-Description')"
          [stylingMode]="'filled'"
          [value]="this.resourceEvent?.comment"
          [ngStyle]="{ width: '672px' }"
          [ngStyle.xs]="{ width: '380px' }"
          valueChangeEvent="keyup"
        >
        </abc-text-area>
      </div>
    </div>
  </div>
</ng-container>
